export function isProjectOpen(deadlineDate: string | null): boolean {
  if (deadlineDate === null) return false;
  const deadline = new Date(deadlineDate);
  return !Number.isNaN(deadline.getTime()) && deadline.getTime() > Date.now();
}
